import React from 'react';
import { Cpu, Zap, Shield, Compass, Sparkles } from 'lucide-react';
import './FutureAgenda.css';

const FutureAgenda = () => {
  const agendaItems = [
    {
      icon: Sparkles,
      title: "Physics-Informed State-Space Models (PI-SSMs)",
      subtitle: "Embedding Physical Conservation Laws into Latent Space",
      description: "Standard deep learning models often violate physical constraints during out-of-distribution shifts. We aim to construct state-space neural architectures whose hidden states strictly respect thermodynamic energy conservation, Kirchhoff load dynamics, and physical fluid conservation laws."
    },
    {
      icon: Cpu,
      title: "Co-Optimization of AI Workloads & Energy Grids",
      subtitle: "Dynamic Spatial-Temporal Compute Dispatch",
      description: "Hyper-scale AI training jobs consume gigawatt-hours of power. We are researching distributed workload orchestrators that dynamically shift compute across geographical data centers based on real-time grid carbon intensity, localized energy prices, and transmission congestion."
    },
    {
      icon: Shield,
      title: "Resilient Infrastructure Under Black Swan Events",
      subtitle: "Continual Learning & Uncertainty Quantification",
      description: "Extreme weather events (e.g. Winter Storm Uri, severe heatwaves) rupture standard statistical assumptions. We build continual learning models equipped with calibrated epistemic uncertainty quantification that adapt autonomously during unprecedented climate or infrastructure disruptions."
    },
    {
      icon: Zap,
      title: "Closed-Loop Autonomous Grid Control",
      subtitle: "Multi-Agent Reinforcement Learning for Energy Transitions",
      description: "As power grids transition to renewable energy sources with sub-second volatility, centralized control becomes intractable. We design multi-agent reinforcement learning protocols for decentralized, real-time node balancing and grid frequency stabilization."
    }
  ];

  return (
    <div className="agenda-page">
      {/* Header Banner */}
      <header className="agenda-header glass">
        <div className="agenda-badge">
          <Compass className="badge-icon" />
          10-Year Research Blueprint
        </div>
        <h1>Future Research Agenda</h1>
        <p className="agenda-lead">
          Building the foundational scientific paradigms to achieve autonomous, resilient, and physics-aware intelligence layers for critical physical infrastructure.
        </p>
      </header>

      {/* Core Agenda Cards */}
      <section className="agenda-grid">
        {agendaItems.map((item, index) => {
          const IconComp = item.icon;
          return (
            <div key={index} className="agenda-card glass glass-hover">
              <div className="agenda-card-header">
                <div className="agenda-icon-box">
                  <IconComp className="agenda-icon" />
                </div>
                <div>
                  <span className="agenda-card-sub">{item.subtitle}</span>
                  <h3>{item.title}</h3>
                </div>
              </div>
              <p>{item.description}</p>
            </div>
          );
        })}
      </section>

      {/* Call to Collaboration */}
      <section className="collab-call glass">
        <h2>Collaborate With Us</h2>
        <p>
          We are actively looking to collaborate with researchers, academic institutions, energy grid operators, and AI labs who share the vision of optimizing critical infrastructure for the future of intelligence.
        </p>
        <div className="collab-contact">
          <a href="mailto:biswadeep@gatech.edu" className="collab-btn">
            Get in Touch
          </a>
        </div>
      </section>
    </div>
  );
};

export default FutureAgenda;
